import {flopShadow, resolveBackground} from '#core/utils/color-utils.js';

export function mobileNavBarAvantgardeFactory(PALETTE) {
    const QUICK_LINKS_PILL = {
        boxSizing: 'border-box',
        height: '48px',
        alignItems: 'center',
        gridTemplateColumns: 'none',
        gridAutoFlow: 'column',
        gridAutoColumns: 'max-content',
        padding: '0 4px',
        borderRadius: '9999px',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: PALETTE.QUICK_LINKS_PILL_BORDER_COLOR,
        ...resolveBackground(PALETTE.QUICK_LINKS_PILL_BG),
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        boxShadow: flopShadow(PALETTE.QUICK_LINKS_PILL_SHADOW),
        flexGrow: 0,
    };

    return {
        QuickLinks: {
            hideOnScroll: true,
            showLabel: false,
            container: {
                style: {
                    boxSizing: 'border-box',
                    height: '48px',
                    bottom: 'calc(12px + env(safe-area-inset-bottom, 0px))',
                    padding: '0 12px',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            groupsContainer: {
                style: {
                    gap: '8px',
                },
            },
            linksContainer: {
                style: QUICK_LINKS_PILL,
            },
            rightLinksContainer: {
                style: {
                    ...QUICK_LINKS_PILL,
                    flexShrink: 0,
                },
            },
            linkButton: {
                style: {
                    base: {
                        backgroundColor: 'transparent',
                        borderRadius: '9999px',
                        padding: '0 10px',
                        height: '100%',
                    },
                },
            },
            linkIcon: {
                style: {
                    minWidth: '28px',
                    minHeight: '28px',
                    fill: PALETTE.LINK_ICON_COLOR,
                    stroke: PALETTE.LINK_ICON_COLOR,
                },
            },
            liveCountBadge: {
                container: {
                    style: {
                        ...resolveBackground(PALETTE.LIVE_COUNT_BADGE_BG),
                    },
                },
                text: {
                    style: {
                        ...PALETTE.LIVE_COUNT_BADGE_TEXT,
                    },
                },
            },
        },
        FloatingBetslipPill: {
            closedBetslipButtonState: {
                container: {
                    style: {
                        transform: 'translate(0, calc(-163px - env(safe-area-inset-bottom, 0px)))',
                    },
                },
            },
        },
    };
}
